module.exports = __webpack_public_path__ + "img/guide_arrow1.1b87b623.png";